import { useContext } from "react";

import { ServicesContext } from "Contexts/Services";

const UseServices = () => {
  const { api } = useContext(ServicesContext);

  return {
    api,
  };
};

export default UseServices;
